import { baseUrl } from "../../../helpers/constants";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import i18n from "i18next";
import { ILuebOption } from "../../../Models/ILuebOption";

export const getSachgruppen = () => {
  return fetchWrapper
    .get(`${baseUrl}/api/vertrieb/getAllSachgruppen`)
    .then((result: any[]) => {
      let options: ILuebOption[] = [{ key: "", text: "" }];

      if (i18n.language.includes("de")) {
        result = result.sort((a, b) =>
          a.benennungDE > b.benennungDE
            ? 1
            : b.benennungDE > a.benennungDE
            ? -1
            : 0
        );
      } else {
        result = result.sort((a, b) =>
          a.benennungEN > b.benennungEN
            ? 1
            : b.benennungEN > a.benennungEN
            ? -1
            : 0
        );
      }

      result.forEach((element: any) => {
        let option: ILuebOption = {
          key: element.sachgruppeGuid,
          text: i18n.language.includes("de")
            ? element.benennungDE
            : element.benennungEN,
        };
        options.push(option);
      });

      return options;
    });
};

export const getArtikelgruppen = () => {
  return fetchWrapper
    .get(`${baseUrl}/api/vertrieb/getAllArtikelgruppen`)
    .then((result: any[]) => {
      let options: ILuebOption[] = [{ key: "", text: "" }];

      if (i18n.language.includes("de")) {
        result = result.sort((a, b) =>
          a.benennungDE > b.benennungDE
            ? 1
            : b.benennungDE > a.benennungDE
            ? -1
            : 0
        );
      } else {
        result = result.sort((a, b) =>
          a.benennungEN > b.benennungEN
            ? 1
            : b.benennungEN > a.benennungEN
            ? -1
            : 0
        );
      }

      result.forEach((element: any) => {
        let option: ILuebOption = {
          key: element.artikelgruppeGuid,
          text: i18n.language.includes("de")
            ? element.benennungDE
            : element.benennungEN,
        };
        options.push(option);
      });

      return options;
    });
};

export const getArtikel = (
  artikelId: string,
  benennung: string,
  sachgruppeGuid: string,
  artikelgruppeGuid: string
) => {
  return fetchWrapper
    .get(
      `${baseUrl}/api/vertrieb/GetArtikel?artikelId=${artikelId}&benennung=${benennung}&sachgruppeGuid=${sachgruppeGuid}&artikelgruppeGuid=${artikelgruppeGuid}`
    )
    .then((result: any[]) => {
      return result;
    });
};
